module.exports = function() {
  this.serverSearch();
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/methods/refresh.js